import * as React from 'react';
import { NoNavigationPageWrapper } from '../../designSystem/layouts/pageWrappers/NoNavigationPageWrapper';
import { PublicPageProvider } from '../_contexts/PublicPageContext';


export function PublicPageWrapper({siteId, children}: {siteId?: string, children: React.ReactNode}): JSX.Element {
    
    return (
        <PublicPageProvider siteId={siteId}>
            <NoNavigationPageWrapper>
                {children}
            </NoNavigationPageWrapper>
        </PublicPageProvider>
    );
}


